import { AxiosError } from 'axios';
import ApiError from '../types/error';

export const isUUID = (id: string): boolean => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
};

export const isSerialNumber = (id: string): boolean => {
  const serialNumberRegex = /^[A-Za-z0-9]{10}$/;
  return serialNumberRegex.test(id);
};

export const isPCUUID = (id: string): boolean => {
  const pcUuidRegex =
    /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/;
  return pcUuidRegex.test(id);
};

export function unmarshalError(
  message: string,
  subError?: AxiosError
): ApiError<AxiosError> {
  const errorRet: ApiError<AxiosError> = {
    message,
    details: subError
  };
  return errorRet;
}

export const isCustomError = (v: ApiError): v is { message: string } =>
  v && typeof v === 'object' && typeof v.message === 'string';

/**
 * Utility function to determine if the polling interval should be cleared for a given key.
 *
 * @param value - The value to check (could be array or string id)
 * @param id - The id to compare
 * @param currentId - The current id stored for the key
 * @returns true if interval should be cleared, false otherwise
 */
export function shouldClearIntervalForKey(
  value: unknown,
  id: string,
  currentId: string | undefined
): boolean {
  return Array.isArray(value) || (currentId !== undefined && id !== currentId);
}

export const handleCopyCode = async (textToCopy: string): Promise<void> => {
  await navigator.clipboard.writeText(textToCopy);
};
